import Axios from "../api/axios";
import config from "../../config";

const getWitnessStatementLetter = () => {
  return Axios.get(`${config.BASE_URL}witness-statement-letter`);
};

export default getWitnessStatementLetter;
